import { jsx as _jsx } from "react/jsx-runtime";
function TriangleDown({ className, size = 24 }) {
    return (_jsx("svg", { className: className, height: size, width: size, fill: "currentColor", viewBox: "0 0 24 24", children: _jsx("path", { d: "M12 15l-5-5h10l-5 5z" }) }));
}
export default TriangleDown;
